import mediaEditorTypes from '../action-types/mediaEditor';

const initialState = {
  saving: false,
};

const mediaEditorReducer = (state = initialState, action) => {
  switch (action.type) {
    case mediaEditorTypes.SAVING_EDITED_MEDIA:
      return {
        ...state,
        saving: action.payload,
      };
    default:
      return state;
  }
};

export default mediaEditorReducer;
